import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  mutation updateNarrativeAnnouncement($input: UpdateAnnouncementInput!) {
    updateNarrativeAnnouncement(input: $input) {
      contentHtml
      id
    }
  }
`);

type Args = VariablesOf<typeof QUERY>['input'];

export const mutationFn = async ({ id, contentHtml }: Args) => {
  const { updateNarrativeAnnouncement, errors } = await gqlClient.request(
    QUERY,
    {
      input: {
        contentHtml,
        id,
      },
    }
  );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return updateNarrativeAnnouncement;
};
